module.exports = __webpack_public_path__ + "img/receipt.e89dbaf8.svg";